// src/apis/materialOutboundOrderApi.ts
// PDA1072_R01 자재출고(작업지시 기준) API

import config from "../config";
import { ResponseDto } from "../dtos/common/responseDto";
import { getData, postData, patchData } from "../utils/axios/serverHelper";
import type {
  PDA1072_R01SearchParams,
  PDA1072_R01HeaderDto,
  PDA1072_R01Dto,
  PDA1072_R01BomLotDto,
  PDA1072_R01MaterialIssueRequest,
} from "src/containers/PDA/PDA1072_R01/PDA1072_R01Dto";

const baseUrl = `${config.apiUrl}/PDA1072_R01`;

// ========== 목록 화면 ==========
export const searchWorkOrders = async (params?: PDA1072_R01SearchParams) => {
  const url = `${baseUrl}/search`;
  return await getData<ResponseDto<PDA1072_R01HeaderDto[]>>(url, { params });
};

export const refetchWorkOrders = async (params?: PDA1072_R01SearchParams) => {
  const url = `${baseUrl}/refetch`;
  return await getData<ResponseDto<PDA1072_R01HeaderDto[]>>(url, { params });
};

// ========== 상세 화면 ==========
export const validateScannedLot = async (
  productOrderNo: string,
  lotNo: string
) => {
  const url = `${baseUrl}/validate-lot/${encodeURIComponent(productOrderNo)}/${encodeURIComponent(lotNo)}`;
  return await getData<ResponseDto<PDA1072_R01BomLotDto>>(url);
};

export const getWorkOrderDetail = async (
  productOrderNo: string,
  warehouseCd?: string
) => {
  const url = `${baseUrl}/order/${productOrderNo}`;
  return await getData<ResponseDto<PDA1072_R01Dto>>(url, {
    params: warehouseCd ? { warehouseCd } : undefined,
  });
};

// ========== 출고 등록/수정 ==========
export const createMaterialIssue = async (
  request: PDA1072_R01MaterialIssueRequest
) => {
  const url = `${baseUrl}`;
  return await postData<PDA1072_R01MaterialIssueRequest, ResponseDto<string>>(url, request);
};

export const updateMaterialIssue = async (
  request: PDA1072_R01MaterialIssueRequest
) => {
  const url = `${baseUrl}`;
  return await patchData<PDA1072_R01MaterialIssueRequest, ResponseDto<string>>(url, request);
};
